import { Injectable } from '@angular/core';

export enum OS {
  MacOS = 'Mac OS',
  iOS = 'iOS',
  Windows = 'Windows',
  Android = 'Android',
  Linux = 'Linux',
  Unknown = 'Unknown'
}

@Injectable({
  providedIn: 'root'
})


export class DeviceService {
  /**
   * Get the browser information.
   */
  public getBrowser(): { browser: string, version: string } {
    const userAgent = navigator.userAgent;
  
    let browser = 'Unknown';
    let version = 'Unknown';
  
    // Detecting browsers
    if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
      browser = 'Chrome';
      version = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/)?.[1] || 'Unknown';
    } else if (/Safari/.test(userAgent) && /Apple Computer/.test(navigator.vendor)) {
      browser = 'Safari';
      version = userAgent.match(/Version\/(\d+\.\d+)/)?.[1] || 'Unknown';
    } else if (/Firefox/.test(userAgent)) {
      browser = 'Firefox';
      version = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1] || 'Unknown';
    } else if (/Edge/.test(userAgent)) {
      browser = 'Edge';
      version = userAgent.match(/Edge\/(\d+\.\d+)/)?.[1] || 'Unknown';
    } else if (/MSIE|Trident/.test(userAgent)) {
      browser = 'Internet Explorer';
      version = userAgent.match(/(MSIE |rv:)(\d+\.\d+)/)?.[2] || 'Unknown';
    }
  
    return { browser, version };
  }

  /**
   * Get the operating system information.
   */
  public getOS(): OS {
      const userAgent = window.navigator.userAgent,
          platform = window.navigator.platform,
          macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
          windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
          iosPlatforms = ['iPhone', 'iPad', 'iPod']
      let os: OS= OS.Unknown;
    
      if (macosPlatforms.indexOf(platform) !== -1) {
        os = OS.MacOS;
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = OS.iOS;
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = OS.Windows;
      } else if (/Android/.test(userAgent)) {
        os = OS.Android;
      } else if (!os && /Linux/.test(platform)) {
        os = OS.Linux;
      }
    
      return os;
  }
}
